import {Translation} from "react-i18next";

export const typeReport = [
    {
        value: 'lateSoonFrequency',
        label:  <Translation>{(t) =>t("tnp.components.report.lateSoonFrequency")}</Translation>,
    },
    {
        value: 'lateSoonMinute',
        label: <Translation>{(t) =>t("tnp.components.report.lateSoonMinute")}</Translation>,
    },
    {
        value: 'totalHour',
        label: <Translation>{(t) =>t("tnp.components.report.totalHour")}</Translation>,
    },
    {
        value: 'noCheckInOut',
        label: <Translation>{(t) =>t("tnp.components.report.noCheckInOut")}</Translation>,
    },
    {
        value: 'moneyPenalty',
        label: <Translation>{(t) =>t("tnp.components.report.moneyPenalty")}</Translation>,
    },
    {
        value: 'totalOvertime',
        label: <Translation>{(t) =>t("tnp.components.report.totalOvertime")}</Translation>,
    },{
        value: 'missionFrequency',
        label: <Translation>{(t) =>t("tnp.components.report.missionFrequency")}</Translation>,
    },
    {
        value: 'absenceFrequency',
        label:  <Translation>{(t) =>t("tnp.components.report.absenceFrequency")}</Translation>,
    }


]